export enum fontWeight {
  ULTRA = 900,
  EXTRA = 800,
  BOLD = 700,
  SEMI = 600,
  MEDIUM = 500,
  REGULAR = 400,
}

export enum fontFamily {
  CATAMARAN = 'Catamaran',
}

export enum fontSize {
  SMALL_EXTRA = '1.2rem',
  SMALL = '1.4rem',
  NORMAL = '1.6rem',
  LARGE = '1.8rem',
  LARGE_XL = '2rem',
  LARGE_XXL = '2.4rem',
  LARGE_XXXL = '3.2rem',
}
